'use client';

import { trpc } from '@/lib/trpc';

// 5 min stale time - payment config can change when admin updates settings
const PAYMENT_CONFIG_CACHE_MS = 1000 * 60 * 5;

/**
 * Hook to fetch public payment configuration for an event.
 * Returns provider type, client key, merchant account, country code,
 * wallet toggles, and currency info needed for checkout rendering.
 *
 * @param eventId - UUID of the event
 */
export function usePaymentConfig(eventId: string | undefined) {
  return trpc.publicPayment.getConfig.useQuery(
    { eventId: eventId! },
    {
      enabled: !!eventId,
      staleTime: PAYMENT_CONFIG_CACHE_MS,
      gcTime: PAYMENT_CONFIG_CACHE_MS * 2,
      refetchOnWindowFocus: false,
    },
  );
}
